// @flow
import type { Address } from '../types/Address';

const defaults: Address = {
  addressLine1: '',
  addressLine2: '',
  city: '',
  state: '',
  zip: '',
  countryCode: '',
  accessToHome: '',
};

export default (address: ?$Shape<Address>): Address => ({
  ...defaults,
  ...address,
});



// WEBPACK FOOTER //
// ../react-lib/src/factories/addressFactory.js